module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_vm._v("Introduction:")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/UncommonDecency1"
    }
  }, [_vm._v("1 Convicted Civility")]), _c('br'), _vm._v("\n  Can We Be Faithful & Polite Too?")]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/UncommonDecency2"
    }
  }, [_vm._v("2 What Christian Civility Is Not")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/UncommonDecency3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Defending Christian Civility")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/UncommonDecency4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Speaking in God's Presence")]), _c('br'), _vm._v("\n  The Importance of Civil Speech")]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/UncommonDecency5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Open Hearts")]), _c('br'), _vm._v("\n  The Importance of Civil Attitudes")]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/UncommonDecency6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 The Spiritual Underpinnings")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/UncommonDecency7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 What’s Good About Pluralism?")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/UncommonDecency8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 How to Be Civil About Sex")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/UncommonDecency9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 The Challenge of Other Religions")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/UncommonDecency10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Christian Leadership in a Pluralistic World")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/UncommonDecency11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 When There Is No “On the Other Hand”")]), _c('br'), _vm._v("\n  The Limits of Civility")]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/UncommonDecency12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Is Hell Uncivil?")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/UncommonDecency13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Abraham Kuyper, Meet Mother Teresa")]), _c('br'), _vm._v("\n  The Problem of Triumphalism")]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/UncommonDecency14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Serving a Slow God")]), _c('br'), _vm._v("\n  Civility and the End of Time")]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword: A Civil Hug")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/eNotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 63
// module chunks = 0